var map = {
	"./addSku.svg": 5845,
	"./book.svg": 9015,
	"./deal.svg": 6461,
	"./home.svg": 7987,
	"./logo.svg": 2391,
	"./logoT.svg": 2355,
	"./quick.svg": 6411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5796;